export const clearLocalStorage = () => {
	let itens = [];
	Object.keys(localStorage).forEach(function(key) {
		if (key.includes('fob_subscribed')) {
			itens[key] = localStorage.getItem(key);
		}
	});
	localStorage.clear();
	for (const [ key, value ] of Object.entries(itens)) {
		localStorage.setItem(key, value);
	}
};
